import React, { ReactNode } from "react"

type VerificationItemProps = {
  icon: ReactNode
  description: ReactNode | string
  actionComponent?: ReactNode
  className?: string
}

const VerificationItem: React.FC<VerificationItemProps> = ({ icon, description, actionComponent, className = "" }) => {
  return (
    <div className={`flex items-start gap-4 ${className}`}>
      <div className="shrink-0">{icon}</div>
      <div className="flex flex-col">
        <p className="text-lg leading-snug text-ui-fg-base">{description}</p>
        {actionComponent && <div className="mt-1">{actionComponent}</div>}
      </div>
    </div>
  )
}

export default VerificationItem
